import React, { useEffect, useRef } from 'react';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {}

const BaseInput = ({ ...props }:Props) => {
    const inputRef = useRef<HTMLInputElement | null>(null); // Explicitly type it as HTMLInputElement or null

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus(); // TypeScript now knows current is an HTMLInputElement
        }
    }, []);

    return (
        <input
            ref={inputRef}
            className="p-1 outline-none bg-black bg-opacity-5 shadow-inner focus:bg-mcia_orange focus:bg-opacity-10 rounded"
            {...props}
        />
    );
};

export default BaseInput;
